<script setup lang="ts">
import { COPPER, MARKET } from '~/constants/services/constants'
import copperData from '~/constants/forecasts/copper'

import MarketWrapper from '~/components/shared/services/MarketWrapper.vue'

import type { TTab } from '@/src/types/common'
import ButtonDownload from '~/components/shared/common/ButtonDownload.vue'

definePageMeta({ layout: 'services' })

const baseUrl = `/${COPPER.slug}/data-reports`
const tabs: TTab[] = [
  {
    slug: 'forecasts',
    name: 'Forecasts',
    url: `${baseUrl}/forecasts`,
  },
  {
    slug: 'copper-briefing',
    name: 'Copper Briefing',
    url: `${baseUrl}/copper-briefing`,
  },
]

const product = COPPER
const productData = copperData
const titlePage = `${COPPER.name} Data & Reports`
const heroImage = productData.hero
const initialFields = [COPPER.slug, MARKET.slug]

const config = useRuntimeConfig()
const activeTab = ref('forecasts')

const downloadText = computed(() => {
  const tabTextMap = {
    'copper-briefing': 'Copper Brochure',
    forecasts: 'Forecast Brochure',
  }

  return tabTextMap[activeTab.value] || 'Methodology'
})

const file = computed(() => {
  const tabFileMap = {
    'copper-briefing': copperData.brochureFile,
    forecasts: copperData.forecastBrochureFile,
  }

  const selectedFile = tabFileMap[activeTab.value]

  if (!selectedFile) return {}

  return {
    ...selectedFile,
    id: selectedFile.EnvKey ? config.public[selectedFile.EnvKey] : '',
  }
})

const setActiveTab = (tab: string) => {
  activeTab.value = tab
}
const { getSeoInfo } = useSeo()

const seo = getSeoInfo({
  title: `${MARKET.name}: ${COPPER.name} Data and Reports`,
})
useHead(seo)
</script>

<template>
  <MarketWrapper
    :initial-fields="initialFields"
    :title-hero="titlePage"
    :image-hero="heroImage"
    :title-page="titlePage"
    :icon="COPPER.iconColor"
    :tabs="tabs"
    has-bookable-demo
    @active-tab-changed="setActiveTab"
  >
    <template #methodology>
      <ButtonDownload
        data-testid="download-button"
        class="mx-0 w-full text-sm font-semibold leading-5 xl:max-w-fit"
        variant="clean"
        :text="downloadText"
        :download-file="file"
      />
    </template>
    <div class="relative">
      <NuxtPage :product="product" :product-data="productData" />
    </div>
  </MarketWrapper>
</template>
